/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { IntlShape } from 'react-intl'
import { UseFormSetValue } from 'react-hook-form'

export const ILLEGAL_NAME_REGEX =
  /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff]|[<>/&_%"*?=]+)/

export const isIllegalName = (str: string): boolean => {
  return ILLEGAL_NAME_REGEX.test(str)
}

export const EMAIL_PATTERN =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,}$/

export const SPACE_PATTERN = /^(?![\s!@#])[^!@#]*(?![\s!@#]).$/

export const isIllegalPwd = (str: string): boolean => {
  if (!str) return true
  return !PASSWORD_PATTERN.test(str)
}

export const nameValidation = (value: string, name: string, intl: IntlShape, setValue: UseFormSetValue<any>) => {
  const _value = stringTrim(value)
  if (!value.match(SPACE_PATTERN)) {
    setValue(name, _value)
  }

  if (_value && isIllegalName(_value)) {
    return intl.formatMessage({
      id: 'signUp.error.illegalName',
    })
  }
}

export const emailValidation = (value: string, name: string, intl: IntlShape, setValue: UseFormSetValue<any>) => {
  const _value = stringTrim(value)
  if (!value.match(SPACE_PATTERN)) {
    setValue(name, _value)
  }

  if (_value && !_value.match(EMAIL_PATTERN)) {
    return intl.formatMessage({
      id: 'error.validator.email',
    })
  }
}

export const stringTrim = (params: any) => {
  const type = typeof params
  let result
  switch (type) {
    case 'object':
      result = Object.assign({}, params)
      for (const key in result) {
        if (typeof result[key] === 'string') {
          result[key] = result[key].trim()
        }
        if (typeof result[key] === 'object') {
          result[key] = stringTrim(result[key])
        }
      }
      break
    case 'string':
      result = params && params.trim()
      break
    default:
      throw new Error('Incoming parameter exception')
  }
  return result
}

export const parseUrl = (url = '') => {
  return url.replace(/&amp;/g, '&')
}

export const removeUrlError = (url = '') => {
  return url.replace(/(&(error=)(\w|\.)+)|((error=)(\w|\.)+&)/g, '')
}
